import {
	GET_STORE_USER_AUTH,
	UPDATE_STORE,
	UPDATE_STORE_ADMIN,
	UPDATE_STORE_SCHEDULE,
	GET_FAQS,
	CREATE_FAQ,
	DELETE_FAQ,
	UPDATE_FAQ,
	GET_TELEGRAM_USERS,
	GET_STORE_SCHEDULE,
	UPDATE_STORE_IMAGE,
	FETCH_START_ADDRESS,
	FETCH_END_ADRESS,
} from "./actions.type";
import api from "../../../api/apibackend";
import {
	SET_STORE,
	SET_FAQS,
	FETCH_START,
	FETCH_END,
	SET_TELEGRAM_USERS,
	FETCH_START_TELEGRAM_USERS,
	FETCH_END_TELEGRAM_USERS,
	SET_STORE_SCHEDULE,
	FETCH_START_STORE_SCHEDULE,
	FETCH_END_STORE_SCHEDULE,
} from "./mutations.type";
import Nprogress from "nprogress";
import Vue from "vue";
import { STORE_DATA } from "../../../commons/constants";

const state = {
	store: null,
	faqs: [],
	storeSchedule: {},
	telegramUsers: { telegram: [], web: [] },
	loadingFaq: false,
	loadingTelegramUsers: false,
	loadingStoreSchedule: false,
	countries: [],
	cities: [],
	states: [],
	loadingAddress: false,
};

const mutations = {
	setStyle(state, palette) {
		Vue.set(state.store.templates, 0, palette);
	},
	[SET_STORE](state, storeData) {
		localStorage.setItem(STORE_DATA, JSON.stringify(storeData));
		state.store = storeData;
	},
	[SET_STORE_SCHEDULE](state, storeSchedule) {
		state.storeSchedule = storeSchedule;
	},
	[SET_FAQS](state, faqs) {
		state.faqs = faqs;
	},
	[FETCH_START](state) {
		Nprogress.start();
		state.loadingFaq = true;
	},
	[FETCH_END](state) {
		Nprogress.done();
		state.loadingFaq = false;
	},
	[SET_TELEGRAM_USERS](state, users) {
		state.telegramUsers = users;
	},
	[FETCH_START_TELEGRAM_USERS](state) {
		Nprogress.start();
		state.loadingTelegramUsers = true;
	},
	[FETCH_END_TELEGRAM_USERS](state) {
		Nprogress.done();
		state.loadingTelegramUsers = false;
	},
	[FETCH_START_STORE_SCHEDULE](state) {
		Nprogress.start();
		state.loadingStoreSchedule = true;
	},
	[FETCH_END_STORE_SCHEDULE](state) {
		Nprogress.done();
		state.loadingStoreSchedule = false;
	},
	[FETCH_START_ADDRESS](state) {
		Nprogress.start();
		state.loadingAddress = true;
	},
	[FETCH_END_ADRESS](state) {
		Nprogress.done();
		state.loadingAddress = false;
	},
	countries(state, countries) {
		state.countries = countries;
	},
	cities(state, cities) {
		state.cities = cities;
	},
	states(state, states) {
		state.states = states;
	},
};

const actions = {
	async [GET_STORE_USER_AUTH]({ commit }) {
		try {
			commit(FETCH_START);
			const res = await api.get(`store/mystore`);
			commit(SET_STORE, res.data);
			commit(FETCH_END);
			return res.data;
		} catch (err) {
			console.error(err);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
			commit(FETCH_END);
		}
	},
	async [UPDATE_STORE]({ commit, dispatch }, store) {
		try {
			commit(FETCH_START);
			const res = await api.patch(`store/${store.id}`, store);
			await dispatch(GET_STORE_USER_AUTH);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Información actualizada exitosamente",
			});
			return res;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al actualizar la información",
			});
			commit(FETCH_END);
		}
		return;
	},
	async [UPDATE_STORE_IMAGE]({ commit, dispatch }, { id, image }) {
		try {
			commit(FETCH_START);
			let formData = new FormData();
			formData.append("image", image);

			const res = await api.post(`store/set_image/${id}`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			await dispatch(GET_STORE_USER_AUTH);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Imagen actualizada exitosamente",
			});
			return res;
		} catch (err) {
			console.log(err);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al actualizar la imagen de la tienda.",
			});
			commit(FETCH_END);
		}
		return;
	},
	async [UPDATE_STORE_ADMIN]({ commit }, store) {
		try {
			commit(FETCH_START);
			const res = await api.patch(`store/${store.id}`, store);
			commit(FETCH_END);
			return res;
		} catch (err) {
			commit(FETCH_END);
		}
		return;
	},
	async [GET_FAQS]({ commit, getters, dispatch }) {
		commit(FETCH_START);
		if (!getters.store) {
			await dispatch(GET_STORE_USER_AUTH);
		}
		return api
			.get(`store/${getters.store.id}/faqs`)
			.then((resFaq) => {
				commit(FETCH_END);
				switch (resFaq.status) {
					case 200:
						const faqs = resFaq.data;
						commit(SET_FAQS, faqs);
						return faqs;
					case 204:
						commit(SET_FAQS, []);
						return [];
				}
			})
			.catch((err) => {
				//console.error(err)
				commit(FETCH_END);
			});
	},
	async [CREATE_FAQ]({ commit, getters, dispatch }, faq) {
		commit(FETCH_START);
		try {
			const res = await api.post(`store/${getters.store.id}/faqs`, faq);
			commit(FETCH_END);
			dispatch(GET_FAQS);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Pregunta creada exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al crear la pregunta",
			});
		}
	},
	async [UPDATE_FAQ]({ commit, dispatch }, faq) {
		commit(FETCH_START);
		try {
			const res = await api.patch(`faqs/${faq.id}`, faq);
			commit(FETCH_END);
			dispatch(GET_FAQS);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Pregunta actualizada exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al actualizar la pregunta",
			});
		}
	},
	async [UPDATE_STORE_SCHEDULE]({ commit, getters }, schedules) {
		commit(FETCH_START);
		try {
			if (!getters.store) {
				await dispatch(GET_STORE_USER_AUTH);
			}
			const res = await api.post(`store/${getters.store.id}/schedule`, {
				schedules: schedules,
			});
			commit(FETCH_END);
		} catch (err) {
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al actualizar el horario",
			});
		}
	},
	async [DELETE_FAQ]({ commit, dispatch }, faqId) {
		try {
			commit(FETCH_START);
			const res = await api.delete(`faqs/${faqId}`);
			commit(FETCH_END);
			dispatch(GET_FAQS);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Pregunta eliminada exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al eliminar la pregunta",
			});
		}
	},
	async [GET_TELEGRAM_USERS]({ commit, dispatch, getters }) {
		try {
			commit(FETCH_START_TELEGRAM_USERS);
			if (!getters.store) {
				await dispatch(GET_STORE_USER_AUTH);
			}
			const res = await api.get(`store/${getters.store.id}/clients`);
			commit(SET_TELEGRAM_USERS, res.data);
			commit(FETCH_END_TELEGRAM_USERS);
		} catch (err) {
			commit(FETCH_END_TELEGRAM_USERS);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_STORE_SCHEDULE]({ commit, dispatch, getters }) {
		try {
			commit(FETCH_START_STORE_SCHEDULE);
			const res = await api.get("store/schedule");
			commit(SET_STORE_SCHEDULE, res.data);
			commit(FETCH_END_STORE_SCHEDULE);
			return res.data;
		} catch (err) {
			commit(FETCH_END_STORE_SCHEDULE);
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	getCountries({ commit }) {
		api.get("countries").then(({ data }) => {
			commit("countries", data.countries);
		});
	},
	async getStates({ commit }, country) {
		commit(FETCH_START_ADDRESS);
		await api
			.get(`states/${country.id}`)
			.then(({ data }) => {
				commit("states", data.states);
			})
			.finally(() => {
				commit(FETCH_END_ADRESS);
			});
	},
	getCities({ commit }, state) {
		commit(FETCH_START_ADDRESS);
		api
			.get(`cities/${state.id}`)
			.then(({ data }) => {
				commit("cities", data.cities);
			})
			.finally(() => {
				commit(FETCH_END_ADRESS);
			});
	},
};

const getters = {
	store: (state) => {
		return state.store || JSON.parse(localStorage.getItem(STORE_DATA));
	},
	countries: (state) => state.countries,
	cities: (state) => state.cities,
	states: (state) => state.states,
	loadingAddress: (state) => state.loadingAddress,
	faqs: (state) => state.faqs,
	loadingFaq: (state) => state.loadingFaq,
	storeSchedule: (state) => state.storeSchedule,
	telegramUsers: (state) => state.telegramUsers,
	loadingTelegramUsers: (state) => state.loadingTelegramUsers,
	getCurrentTemplate: (state) => {
		if (state.store && state.store.templates) {
			return state.store.templates[0];
		}
		return null;
	},
};

export default {
	actions,
	state,
	getters,
	mutations,
};
